let apiServices = {};
let apiUrlConfigs = null;

export const UsersConfigSetter = {
  apiServices: apiServiceConfigs => {
    apiServices = apiServiceConfigs;
  },
  url: apiUrls => {
    apiUrlConfigs = apiUrls;
  }
};

export const getPreferences = () => {
  const url = apiUrlConfigs.getNotificationPreferencesUrl;
  const { Get } = apiServices;
  return Get(url);
};

export const sendEnableNotificationToggle = requestBody => {
  const url = apiUrlConfigs.getNotificationPreferencesUrl;
  const { Post } = apiServices;

  return Post(url, requestBody, true);
};

export const getWebNotifications = () => {
  const url = apiUrlConfigs.getWebNotificationsUrl;
  const { Get } = apiServices;
  return Get(url);
};

export const patchWebNotifications = requestBody => {
  const url = apiUrlConfigs.patchWebNotificationsUrl;
  const { Patch } = apiServices;
  return Patch(url, requestBody);
};

export default UsersConfigSetter;
